require("./bootstrap");
require("./components");

import get_main_url from './lib/get_main_url';
import log from "./lib/log";
import http from "./lib/http";
import App from "./views/app/App";
import router from "./routes";
import store from "./store";
import pkg from '../package.json';

import Vue from "vue";
import * as Sentry from '@sentry/vue';

Sentry.init({
  Vue,
  release: `${pkg.name}@${pkg.version}`,
  dsn: process.env.VUE_APP_SENTRY_DSN || '',
  // отключиние отслеживание сессий клиента, записываются только события ошибок
  autoSessionTracking: false,
  // отключение отслеживания производительности трейсов
  traceSampleRate: 0.0,
  // только 10% ошибок от общего кол-ва будут записываться в sentry
  sampleRate: 0.1,
  // вывод ошибок в консоль, работает только если запущен через npm run serve
  logErrors: process.env.NODE_ENV === 'development',
  // прикреплять данные props компонента при ошибке
  attachProps: true,
  // фильтрация ненужных ошибок
  beforeSend(event) {
    const ignoreMessages = [
      'Script error.',
      'Network Error',
      'Request failed with status code 404',
    ];
    if (event.message && ignoreMessages.some(msg => event.message.includes(msg))) {
      return null;
    }
    return event;
  },
});

Vue.config.errorHandler = (err, vm, info) => {
  // Отправить ошибку в Sentry
  Sentry.captureException(err);

  log.error(err, vm, info);
};
Vue.config.productionTip = false;

Vue.prototype.$main_url = get_main_url.mainUrl;
Vue.prototype.$login_main_url = get_main_url.loginMainUrl;
Vue.prototype.$recaptcha_key = process.env.VUE_APP_RECAPTCHA_SITEKEY || 'empty';

if (!Vue.prototype.$main_url) {
    alert("For developers\n\nPlease make file .env.development in project root directory with content\n\tVUE_APP_MAIN_URL = 'http://crmka.back.test'\nand restart npm run serve")
    throw 'VUE_APP_MAIN_URL is undefined'
}

Vue.prototype.$langs = {
    ru: {
        title: "Русский",
        for_lang: "Для русского языка",
        sign: "RU",
    },
    en: {
        title: "English",
        for_lang: "For english",
        sign: "EN",
    },
};

http.setStore(store);

new Vue({
  router,
  store,
  template: "<App/>",
  render: h => h(App)
}).$mount("#app");

router.beforeEach((to, from, next) => {
  // При входе по `/?token=...&refererUrl=...` нельзя сразу редиректить на /orders.
  if (to.path === '/' && (to.query.token || to.query.refererUrl)) {
    next();
    return;
  }

  if (to.fullPath == '/') {
    // После логина пользователь попадает на / до загрузки auth_user. Если есть refererUrl,
    // не переводим сразу на /orders — watch в App.vue переведёт на исходную страницу.
    const refererUrl = localStorage.getItem('refererUrl');
    const isPostLoginWithReferer = refererUrl && !store.state.users.auth_user;
    if (isPostLoginWithReferer) {
      next();
      return;
    }

    // редирект с корня сайта
    console.log('transition from the main');
    if (store.state.users.auth_user && store.state.users.auth_user.mainlink != '/') {
      router.push(store.state.users.auth_user.mainlink);
    } else {
      router.push('/orders');
    }
  } else {
    document.title = to.meta.label;
    next();
  }
});

router.afterEach((to, from) => {
if(store.state.users.auth_user){
    if(store.state.users.auth_user.lang != 'ru' && to.meta['label_'+store.state.users.auth_user.lang]){
        document.title = to.meta['label_'+store.state.users.auth_user.lang];
    }
}
})
